import React, { useEffect, useState } from "react";
import { FaInfoCircle } from "react-icons/fa";
import { Button, Row, Col, Modal, Typography, notification } from "antd";
import { MdLockOutline } from "react-icons/md";

const { Title, Text } = Typography;


const RetrieveModal = () => {


  const userId = localStorage.getItem('userId')  
  const token = localStorage.getItem('accessToken')
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [retrieveData, setRetrieveData] = useState(null)


  const fetchSubscriptDetails = async () =>{
    try {
     const response = await fetch(`https://verse.blaccdot.com/ldsbackend/masters/usersubscription/latestuserplan/${userId}`)

     if(response.ok){
      const result = await response.json()
      setRetrieveData(result?.data?.subscriptionplan?.Subscriptiondetails)
      handleCancel()

     }else{
      alert("Failed to fetch subscription details");
     }
    } catch (error) {
      alert("API request failed");
    }
  }

  useEffect(()=>{
    fetchSubscriptDetails()
  },[])

  const handleSubscriptReve = async () =>{
    const provinceIdArray = JSON.parse(localStorage.getItem('provinceid')) || [];    
    const domainid = localStorage.getItem('domainid')

    const payload = {
      plantype: "Normal",
      country:'United Kingdom',
      userId: userId,
      subscriptionId: retrieveData.subscriptionmasterId || retrieveData.CustommasterId ,
      // subscriptionId: retrieveData.subscriptionmasterId ? retrieveData.CustommasterId : 0, 
      provinceId: provinceIdArray,
      longDistanceLeads: true,
      amount: retrieveData.amount, 
      taxAmount: retrieveData.taxAmount,
      credit: retrieveData.creditpoints, 
      category:domainid,
  }
    try {
    const response = await fetch(`https://verse.blaccdot.com/ldsbackend/campaign/create`,{
            method:'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `${token}`
            },
            body: JSON.stringify(payload)
        }) 
        const responseData = await response.json();
        console.log('Response Data', responseData);

        if (response.ok) {
            notification.info({
                message: 'Session Expired',
                description: 'Your session has expired. Please log in again.',
                placement: 'top',
                duration: 0,
                closeIcon: null, 
                btn: (
                  <Button onClick={handleLogout} type="primary">
                    Logout
                  </Button>
                ),
              });
          //  handleCancel()
        } else {
         alert('Failed to Pay');
        }
    } catch (error) {
        alert('Failed to Pay:', error);
    }
  }
  

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleLogout = ()=>{
    notification.destroy(); 
  }

  
  return (
    <>
      <Modal open={isModalOpen} onOk={handleOk} onCancel={handleCancel}
        footer={null} width={500} centered className="payment-modal" >
        <div style={{ padding: "20px" }}>
          <Row align="middle" gutter={[8, 8]} style={{ marginBottom: "24px" }}>
            <Col>
              <MdLockOutline style={{ fontSize: "24px", color: "#7281FF" }} />
            </Col>
            <Col>
              <Title level={4} style={{ margin: 0, fontWeight: 700 }}>
                Secure Payment
              </Title>
            </Col>
          </Row>
          {/* Plan Details Section */}
          <div style={{
              background: "#f8f9fa",
              borderRadius: "8px",
              padding: "16px",
              marginBottom: "24px", }}>
            <Title level={5} style={{ marginBottom: "16px", color: "#2d3436" }}>
              Order Summary
            </Title>
           

            <Row gutter={[16, 16]} style={{ marginBottom: "12px" }}>

              <Col span={12}>
                <Text type="secondary">Plan Name</Text>
                <Text strong style={{ display: "block" }}>
                   {retrieveData ? retrieveData.title : (
                      <div style={{marginLeft:'25px', marginTop:'10px'}}>
                            <div className="payloader"></div>
                      </div>
                   )}
                </Text>
              </Col>
              <Col span={12}>
                <Text type="secondary">Credits</Text>
                <Text strong style={{ display: "block" }}>
                {retrieveData ? retrieveData.creditpoints : (
                   <div style={{marginLeft:'25px', marginTop:'10px'}}>
                   <div className="payloader"></div>
                  </div>
                )}
                </Text>
              </Col>
            </Row>

            <Row gutter={[16, 16]}>
              <Col span={12}>
                <Text type="secondary">Subtotal</Text>
                <Text strong style={{ display: "block" }}>
                  {retrieveData ? (retrieveData.monthAmount ? retrieveData.monthAmount : retrieveData.amount) : "0.00"}  {retrieveData?.currency}
                </Text>
              </Col>
              <Col span={12}>
                <Text type="secondary">Tax Amount</Text>
                <Text strong style={{ display: "block" }}>
                  {retrieveData ? retrieveData.taxAmount : "0.00"} {retrieveData?.currency}

                </Text>
              </Col>
            </Row>
          </div>
          {/* Total Amount */}
          <Row justify="space-between" align="middle"
            style={{ marginBottom: "32px", padding: "16px 0",  borderTop: "1px solid #e8e8e8",}} >
            <Col>
              <Text strong style={{ fontSize: "16px" }}>
                Total Amount
              </Text>
            </Col>
            <Col>
              <Title level={3} style={{ margin: 0, color: "#7281FF" }}>
              
              {retrieveData
                ? (retrieveData.monthAmount + retrieveData.taxAmount).toFixed(2)
                : "0.00"}  {retrieveData?.currency}
              </Title>
            </Col>
          </Row>
          {/* Security Assurance */}
          <Row align="middle" gutter={[8, 8]} style={{ marginBottom: "24px" }}>
            <Col>
              <MdLockOutline style={{ fontSize: "16px", color: "#63BB35" }} />
            </Col>
            <Col>
              <Text type="secondary" style={{ fontSize: "12px" }}>
                Your payment is securely encrypted with SSL technology
              </Text>
            </Col>
          </Row>

          <Button type="primary" block size="large" onClick={handleSubscriptReve}
            style={{ height: "48px", fontSize: "16px",backgroundColor: "#7281FF", borderRadius: "8px" }} >
            Confirm Payment
          </Button>
        </div>
      </Modal>


      <div
        style={{
          backgroundColor: "#e6f4ff",
          border: "1px solid #91caff",
          borderRadius: "8px",
          padding: "16px",
          margin: "16px 0",
          position: "relative",
        }}>
        {/* Row for Icon & Title */}

        <Row align="middle" gutter={[8, 8]}>
          <Col>
            <FaInfoCircle style={{ fontSize: "20px", color: "#1677ff" }} />
          </Col>
          <Col flex="auto">
            <h6
              style={{
                margin: 0,
                fontSize: "16px",
                fontWeight: 600,
                color: "#1677ff",
              }}>
              Renew plan my current plan
            </h6>
          </Col>
        </Row>

        {/* Description & Button */}
        <Row style={{ marginTop: "10px" }}>
          <Col span={24}>
            <p
              style={{
                color: "#595959",
                fontSize: "14px",
                lineHeight: "1.6",
                marginBottom: "8px",
              }}>
              Would you like to renew your current plan again?
            </p>

            <Button
              onClick={() => showModal()}
              type="default"
              style={{ borderColor: "#1677ff", color: "#1677ff" }}
            >
              Subscribe Now
            </Button>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default RetrieveModal;
